import { ApiResponse, http } from '@config/api';
import Cookies from 'js-cookie';

export interface Crop {
	id: string;
	name: string;
	country_code: string;
	image_url: string;
}

export async function getAllCrops(): Promise<Crop[]> {
	const response = await http.get<ApiResponse<Crop[]>>('crops', 'list/');

	return response.data.data;
}

// export async function getCropsByIds(ids: string[]): Promise<Crop[]> {
// 	const response = await http.post<ApiResponse<Crop[]>>('crops', 'list/get-by-id/', {
// 		ids: ids,
// 	});

// 	return response.data.data;
// }

export async function getCropsByIds(ids: any): Promise<Crop[]> {
	const response = await http.get<ApiResponse<Crop[]>>('crops', 'list/get-by-id', {
		ids: ids.join(','),
	});

	return response.data.data;
}

export async function getCropsByIdsPost(ids: any): Promise<Crop[]> {
	const accessToken = Cookies.get('accessToken');
	const response = await http.post<ApiResponse<Crop[]>>(
		'crops',
		'list/get-by-id/',
		{
			ids: ids,
		},
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		}
	);

	return response.data.data;
}

export async function getAllMonitoringCrops(): Promise<Crop[]> {
	const response = await http.get<ApiResponse<Crop[]>>(
		'crops',
		'list/get-supported-crops-for-monitoring/'
	);

	return response.data.data;
}
